module.exports = __webpack_public_path__ + "static/img/UK.a1df019.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/destination/UK.jpg
// module id = d4cM
// module chunks = 1